/**
 * changement-coordonnees-mouvement
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Indicateurs lors de la modification du profil du membre
 */
export interface IndicateursMouvementModification {
  /**
   * Preference de contact du membre pour DGAG
   */
  preferenceContactDGAG?: IndicateursMouvementModificationPreferenceContactDGAGEnum;
}
export enum IndicateursMouvementModificationPreferenceContactDGAGEnum {
  MATIN = 'MATIN',
  APRES_MIDI = 'APRES-MIDI',
  SOIR = 'SOIR',
  AUCUNE_PREFERENCE = 'AUCUNE_PREFERENCE',
  NE_PAS_TRANSMETTRE_LE_CHANGEMENT = 'NE_PAS_TRANSMETTRE_LE_CHANGEMENT',
}
